import { type ModuleApiInfo } from "@client/content/selectors";
import Loading from "@client/controls/Loading/component";
import { getUnwrapResponse } from "@client/lib/api";
import { usePromise } from "@client/lib/hooks";
import { type WithId } from "@client/types";
import AffiliateLeaderboard from "@common/modules/affiliate/Leaderboard/component";
import React from "react";
import api from "../../api";
import { BackContainer } from "../Back";

import "./style.less";

export type MapProps = WithId & {
  apiInfo: ModuleApiInfo;
  cycleEndDate: string;
  incentiveId: string;

  onBackClick: () => void;
};

export type ActionProps = {};

export default (props: ActionProps & MapProps) => {
  const [data, isLoadingData] = usePromise({
    fn: getUnwrapResponse(api.getLeaderboard),
    args: [props.apiInfo, props.incentiveId],
    shouldLoad: true
  });

  const loadPage = React.useCallback(
    (page: number, size: number) => {
      return getUnwrapResponse(api.getLeaderboardPage)(props.apiInfo, props.incentiveId, page, size);
    },
    [props.apiInfo, props.incentiveId]
  );

  return (
    <BackContainer onBackClick={props.onBackClick}>
      {isLoadingData ? (
        <Loading />
      ) : data ? (
        <AffiliateLeaderboard
          competition={data.incentive}
          currentItem={data.current}
          loadPage={loadPage}
          rewards={data.rewards}
        />
      ) : (
        "Leadboard isn't available"
      )}
    </BackContainer>
  );
};
